




























































































import { Component, Vue, Prop } from "vue-property-decorator";
import ReusableButton from "@/components/ReusableButton.vue";
import {
  Configuration,
  SelectedCountry,
  RedCapital,
  TitleTemplateDashboard,
} from "@/configuration";
import { mapState } from "vuex";
import API from "@/api";
import { EventBus } from "@/main";
import { Compania } from '@/models/Company';
import ShowLoading from "@/components/panel/ShowLoading.vue";
import { orderComunas, extraerInfoDireccion, formatoNuevoDireccion } from "@/utils";
import Address from "@/components/Address.vue";


@Component({
  metaInfo: {
    title: "Editar empresa",
    titleTemplate: TitleTemplateDashboard,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  computed: {
			...mapState(["setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			},
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      btn: {
        clickable: false,
        loading: false,
        isOk: null,
        successText: "Guardado correctamente",
        errorText: "Error interno",
      },
      oldCompany: null,
      company: {} as Compania,
      countries: null,
      regions: null,
      communes: null,
      radioOption: false,
      siiPassword: false,
      targets: [
        {
          id: 1,
          name: "Personas",
        },
        {
          id: 2,
          name: "Empresas",
        },
        {
          id: 3,
          name: "Ambas",
        },
      ],
      rules: {
        notEmpty: [(v: string) => !!v || "Este campo es requerido"],
        direcc: [(v: string) => !!v || "La dirección es requerida"],
        telf: [(v: string) => !!v || "El teléfono es requerido"],
        cr: [(v: string) => !!v || "El correo es requerido"],
        cm: [(v: string) => !!v || "La comuna es requerida"],
        rg: [(v: string) => !!v || "La región es requerida"],
      },
      isLoading: false,
      valid: true,
      cargandoRegiones: false,
      cargandoComunas: false,
      canShow: false,
      direccionCompleta: '',
      disabledRegion: true,
      disabledComuna: true,
      uniqueId: 'autocomplete_' + Math.random().toString(36).substr(2, 9),
      addressData: {
        address: "",
        number_street: "",
        dpto_casa: "",
        region: '',
        comuna: '',
        pais: 'Chile'
      },
    };
  },
  watch: {
    company: {
      handler(val) {
        if (this.$refs.editForm != null) {
          // @ts-ignore
          if (this.$refs.editForm.validate()) {
            // @ts-ignore
            this.$data.btn.clickable = this.hasChange();
          } else {
            this.$data.btn.clickable = false;
          }
        }
      },
      deep: true,
    },
  },
  async beforeMount() {
    //@ts-ignore
    const compa: Compania = await API.getCompany(this.$props.companyId);
     //@ts-ignore
    let temp1: Compania = {};
     //@ts-ignore
    let temp2: Compania = {};

    Object.assign(temp1, compa);
    Object.assign(temp2, compa);
    if(!temp1.giros){
      var giros = {
        id:0,
        descripcion: '',
        cod:0
      }
      temp1.giros = giros
    }
    if(!temp1.giro){
      temp1.giro = 0;
    }
    if(!temp1.comuna_id){
      temp1.comuna_id = 0;
    }

    this.$data.company = temp1;

    this.$data.oldCompany = temp2;


    // this.$data.countries = await API.getCountries();
    this.$data.company.pais_id = 1;
    this.$data.cargandoRegiones = true;
    await API.getRegions()
				.then((res: any) => {
					this.$data.regions = res.filter((el: any) => {
						return (
							el.name == "Valparaíso" || el.name == "Región Metropolitana"
						);
					});
				})
				.catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoRegiones = false;
        })
    this.$data.cargandoComunas = true;
    API.getCommunes(this.$data.company.region_id)
        .then((res: any) => {
          let parcialComunas = res.filter((el: any) => {
            return (
              el.name == "Colina" || 
              el.name == "Lampa" || 
              el.name == "Lo Barnechea" || 
              el.name == "Tiltil" || 
              el.name == "Calle Larga" || 
              el.name == "Catemu" || 
              el.name == "Llay Llay" || 
              el.name == "Los Andes" || 
              el.name == "Nogales" || 
              el.name == "Panquehue" || 
              el.name == "Rinconada" || 
              el.name == "San Esteban" || 
              el.name == "San Felipe" 
            );
          });
          this.$data.communes = orderComunas(parcialComunas);
        })
        .catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoComunas = false;
        })
    if(this.$data.company.telefono && this.$data.company.telefono.substr(0,2) == '56'){ // comprueba si el numero viene con el 56 y lo elimina.
      this.$data.company.telefono = this.$data.company.telefono.slice(2);
    }
    //@ts-ignore
    this.formatearDireccion();
    this.$data.canShow = true;
  },
  methods: {
    editCompany() {
      // @ts-ignore
      if (this.$refs.editForm.validate()) {
        this.$data.isLoading = true;
        API.editCompany(this.$data.company)
          .then((result) => {
            this.$data.oldCompany = this.$data.company;
            this.$data.company = this.$data.oldCompany;
            this.$data.isLoading = false;
            EventBus.$emit("alerts", true,'¡Atención!',"Tus datos fuerona actualizados con éxito!")
            setTimeout(() => {
              EventBus.$emit("alerts", false,'',"")
              this.$router.push({
                path: "/panel-facto/estadisticas",
              });
            }, 2000);
            // @ts-ignore
            this.$data.btn.clickable = this.hasChange();
          })
          .catch((error) => {
            EventBus.$emit("snack-error", error);
            EventBus.$emit("alertsError", true,'¡Atención!',"Error al actualizar, intente más tarde!")
            setTimeout(() => {
              EventBus.$emit("alertsError", false,'',"")
              
            }, 2000);
            this.$data.isLoading = false;
          });
      }
    },
    hasChange() {
      let oldData = Object.values(this.$data.oldCompany);
      let newData = Object.values(this.$data.company);

      let hasSomethingChange = false;

      for (let i in oldData) {
        if (oldData[i] != newData[i]) {
          if (newData[i] == "") {
            continue;
          }
          hasSomethingChange = true;
        }
      }

      return hasSomethingChange;
    },
    async updateCommunes() {
      this.$data.cargandoComunas = true;
      API.getCommunes(this.$data.company.region_id)
        .then((res: any) => {
          let parcialComunas = res.filter((el: any) => {
            return (
              el.name == "Colina" || 
              el.name == "Lampa" || 
              el.name == "Lo Barnechea" || 
              el.name == "Tiltil" || 
              el.name == "Calle Larga" || 
              el.name == "Catemu" || 
              el.name == "Llay Llay" || 
              el.name == "Los Andes" || 
              el.name == "Nogales" || 
              el.name == "Panquehue" || 
              el.name == "Rinconada" || 
              el.name == "San Esteban" || 
              el.name == "San Felipe" 
            );
          });
          this.$data.communes = orderComunas(parcialComunas);
        })
        .catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoComunas = false;
        })
    },
    getFormattedAddress(address){
      this.$data.direccionCompleta = null;
      this.$data.direccionCompleta = address;
      this.$data.company.direccion = this.$data.direccionCompleta;

    },
    async getDataDireccion(data) {
      const [region, comuna] = data;
      const region_id = this.$data.regions.filter((regionItem:any) => regionItem.name === region);
      if(region_id.length !== 0){
        this.$data.disabledRegion = true;
        this.$data.disabledComuna = true;

        this.$data.company.region_id = region_id[0].id;
        this.$data.addressData.region = region_id[0].name;

        //@ts-ignore
        this.updateCommunes();
        API.getCommunes(region_id[0].id).
        then((res : any) => {
          let parcialComunas = res.filter((el: any) => {
            return (
              el.name == "Colina" || 
              el.name == "Lampa" || 
              el.name == "Lo Barnechea" || 
              el.name == "Tiltil" || 
              el.name == "Calle Larga" || 
              el.name == "Catemu" || 
              el.name == "Llay Llay" || 
              el.name == "Los Andes" || 
              el.name == "Nogales" || 
              el.name == "Panquehue" || 
              el.name == "Rinconada" || 
              el.name == "San Esteban" || 
              el.name == "San Felipe" 
            );
          });

          this.$data.communes = orderComunas(parcialComunas);
          //@ts-ignore
          const comuna_id = this.$data.communes.filter((comunaItem) => comunaItem.name === comuna);
          
          if(comuna_id.length !== 0){
            this.$data.company.comuna_id = comuna_id[0].id;
            this.$data.addressData.comuna = comuna_id[0].name;
          }else{
            this.$data.disabledComuna = false;
          }
        })

      }else{
        //en caso que no encuentre la region se da la posibilidad que la escoja
        this.$data.disabledRegion = false;
        this.$data.disabledComuna = false;
      }
    },
    async getDataDireccion2(data) {
      const [region, comuna] = data;

      const region_id = this.$data.regions.filter((regionItem:any) => regionItem.id === region);
      if (region_id.length !== 0) {
        this.$data.disabledRegion = true;
        this.$data.disabledComuna = true;
        this.$data.addressData.region = region_id[0].name;

        const comunas = await API.getCommunes(region_id[0].id);;
        //@ts-ignore
        const comuna_id = comunas.filter((comunaItem) => comunaItem.id === comuna);
        if (comuna_id.length !== 0) {
          this.$data.addressData.comuna = comuna_id[0].name;
          this.$data.disabledComuna = true;
        } else {
          this.$data.disabledComuna = false;
        }
      } else {
        // En caso de que no se encuentre la región, habilita las opciones
        this.$data.disabledRegion = false;
        this.$data.disabledComuna = false;
      }
    },
    updateAddressData(data) {
      this.$data.addressData = data;
    },
    formatStreet(data){
      this.$data.addressData.address = data;
    },
    formatearDireccion(){

      let isNewFormat = formatoNuevoDireccion(this.$data.company.direccion);
      if(isNewFormat){
        this.$data.addressData.number_street = extraerInfoDireccion(this.$data.company.direccion).numeroCalle;
        this.$data.addressData.dpto_casa = extraerInfoDireccion(this.$data.company.direccion).numeroDptoCasa;
        this.$data.addressData.pais = extraerInfoDireccion(this.$data.company.direccion).pais != '-' ? extraerInfoDireccion(this.$data.company.direccion).pais : 'Chile';
        this.$data.addressData.address = extraerInfoDireccion(this.$data.company.direccion).calle;
      }else{
        this.$data.addressData.number_street = '';
        this.$data.addressData.dpto_casa = '';
        this.$data.addressData.pais = 'Chile';
        this.$data.addressData.address = this.$data.company.direccion;
      }

      //@ts-ignore
      this.getDataDireccion2([this.$data.company.region_id,this.$data.company.comuna_id])
    },
    formatNumberStreet(data){
      this.$data.addressData.number_street = data;
    },
  },
  components: {
    ReusableButton,
    ShowLoading,
    Address
  },
})
export default class EditBusiness extends Vue {
  @Prop() companyId!: number;
}
